import { Component, OnInit } from '@angular/core';
import { FaqService } from './faq.service';
import { CommonService } from '../common/services/common.service';
import { ToasterService } from '../common/toaster/toaster.service';

import { Title, Meta } from '@angular/platform-browser';

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.css']
})
export class FaqComponent implements OnInit {


  email: String;
  message: String;
  constructor( private _faqService: FaqService,private _commonService: CommonService, private toaster: ToasterService,private titleService: Title, private metaService: Meta) { }

  ngOnInit() {
    this.titleService.setTitle('Veelgestelde vragen l Ticketvoordeel.nl');
    this.metaService.addTags([
      {name: 'keywords', content:'Goedkope vliegtickets turkije. Veelgestelde vragen'},
      {name: 'description', content: 'Heeft u een vraag over uw boeking bij Ticketvoordeel.nl? Raadpleeg eerst onze ‘veelgestelde vragen’ pagina. '},
      {name: 'robots', content: 'index, follow'}
    ]);
  }

  scrollToView(id) {
    const elementId = document.getElementById(id);
    elementId.scrollIntoView({behavior: 'smooth', block: 'start'});
  }

  sendFaqMessage() {
    if(this.email != undefined && this.message != undefined){
    this._faqService.sendFaqRequest(this.email, this.message).subscribe((response: any) => {
      // this._commonService.showToast('success','send success');
      if (response.body.status && response.body.message === 'success') {
        // this.lastMinDeals = response.data;
        // alert("Success");
        // this._commonService.showToast('success','send success');
        this.toaster.show('success','Successfully sent message');
         
      } else {
        //  this.triggerNoResultsModal();
        this.toaster.show('error','Message not sent');
         }
    });
  }else{
    this.toaster.show('error','Please fill all fields');
  }
  }

}
